// Store para controle de Banco
export default {
  namespaced: true,
  state: {
    deveRecarregarLista: false,
    registroSelecionadoId: null
  },
  getters: {
    DEVE_RECARREGAR_LISTA: state => state.deveRecarregarLista,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId
  },
  mutations: {
    SET_DEVE_RECARREGAR_LISTA: (state, payload) => { 
      state.deveRecarregarLista = payload 
    },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
      state.registroSelecionadoId = payload
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/banco-store.js